<template>
  <div>
    <div class="leave-list-wrap">
      <!-- <div class="leave-list-title">请假审批</div> -->
      <div class="leave-list" v-if="list.length > 0">
        <div
          class="leave-list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="clickLeaveDetail(item)"
        >
          <div class="cause flex flex-b flex-vc">
            <span
              >{{ item.leaveName }} {{ item.leaveType
              }}{{ renderTime(item.leaveTime) }}</span
            >
            <!-- <span
              class="status"
              v-if="item.leaveState == 0"
              @click.stop="changStatus(item)"
              >同意申请</span
            >
            <span class="status" v-if="item.leaveState == 1">已同意</span>
            <span class="status" v-if="item.leaveState == -1">已拒绝</span> -->
            <van-tag
              plain
              type="success"
              v-if="item.cancelLeaveState == 2"
              size="medium"
              >已通过</van-tag
            >
            <van-tag
              plain
              type="primary"
              size="medium"
              v-if="item.cancelLeaveState == 1"
              >待审批</van-tag
            >
            <van-tag
              plain
              type="danger"
              size="medium"
              v-if="item.cancelLeaveState == -1"
              >已驳回</van-tag
            >
            <van-tag
              plain
              type="danger"
              size="medium"
              v-if="item.cancelLeaveState == -2"
              >已过期</van-tag
            >
          </div>
          <!-- <div class="date"><span>申请人：</span><span></span></div> -->
          <div class="date">
            <span>开始时间：</span
            ><span>{{ getDateYMD(item.leaveBeginTime) }}</span>
          </div>
          <div class="date">
            <span>结束时间：</span
            ><span>{{ getDateYMD(item.leaveEndTime) }}</span>
          </div>
          <div class="note">
            <span>请假原因：</span><span>{{ item.remark }}</span>
          </div>
        </div>
      </div>
      <div class="" v-else>
        <van-empty description="暂无数据" />
      </div>
      <van-dialog
        v-model="show"
        show-cancel-button
        close-on-click-overlay
        title="温馨提示"
        @confirm="onConfirm"
        @cancel="show = false"
      >
        <div class="dialog-wrap">
          <van-row>
            <van-col :span="8">
              申请状态：
            </van-col>
            <van-col :span="16">
              <van-radio-group v-model="radio" direction="horizontal">
                <van-radio name="1">同意</van-radio>
                <van-radio name="-1">拒绝</van-radio>
              </van-radio-group>
            </van-col>
          </van-row>
          <van-row style="margin-top: 20px;" v-if="radio == '-1'">
            <van-col :span="24">
              备注
            </van-col>
            <van-col :span="24">
              <input type="text" class="cell-wrap" v-model="auditRemark" />
            </van-col>
          </van-row>
          <!-- {{ dialogMsg }}
          <input type="text" class="remark-input" placeholder="备注" />
          <div v-if="columns.length > 0">
            <div class="dialog-item-title">选择下一位审批人</div>
            <div class="cell-wrap" @click="showSelectPerson = true">
              {{ pickerItem.deptName || '' }} {{ pickerItem.name || '' }}
            </div> -->
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { compare, getDateYMD, timeFormart } from '@/utils'
import moment from 'moment'
export default {
  data() {
    return {
      list: [],
      radio: '1',
      show: false,
      auditRemark: '',
      item: {},
    }
  },
  mounted() {
    console.log('被执行123123')
    Promise.all([
      this.getLeaveOffListAudit(0),
      this.getLeaveOffListAudit(1),
      this.getLeaveOffListAudit(-1),
      // this.getApproveLeaveList(-2),
    ]).then((res) => {
      this.$store.commit('setTabBadge', {
        type: 'leaveoff',
        value: res[0].list.length || '',
      })
      res.forEach((item) => {
        item.list && item.list.forEach((v) => {
          v.state = this.getStatus(v.leaveState)
          v.du = this.duration(v.leaveBeginTime, v.leaveEndTime)
          this.list.push(v)
        })
      })
    })
  },
  methods: {
    getDateYMD,
    duration(b, e) {
      var m1 = moment(b),
        m2 = moment(e)
      var du = moment.duration(m2 - m1, 'ms'),
        day = du.get('days'),
        hours = du.get('hours'),
        mins = du.get('minutes'),
        ss = du.get('seconds')
      const duration = day + '天' + hours + '时' + mins + '分' + ss + '秒'
      return duration
      // this.$set(this.form, 'visitorIdCrde', duration)
    },
    changStatus(item) {
      this.show = true
      this.item = item
    },
    async onConfirm() {
      const { code, data } = await this.$https.approveLeave({
        auditId: this.$store.state.userId,
        auditRemark: this.auditRemark,
        id: this.item.id,
        leaveState: this.radio,
      })
      if (code !== 200) {
        this.$toast('审批失败，请重试')
        return
      }
      if (this.radio == 1) {
        this.$toast('审批成功')
        this.item.leaveState = 1
      } else {
        this.$toast('拒绝成功')
        this.item.leaveState = -1
      }
    },


    clickLeaveDetail(item) {
      this.item = item
      this.$router.push({
        path: '/leavedetail',
        query: { type: 'au', id: item.id,approvalId: item.approvalId },
      })
    },
    getStatus(state) {
      let map = {
        0: '待审批',
        1: '已同意',
        '-1': '已拒绝',
      }
      return map[state]
    },
    async getLeaveOffListAudit(state) {
      const { data, code } = await this.$https.leaveOffListAudit({
        leaveState: state,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      })
      if (code !== 200) {
        return false
      }
      return Promise.resolve(data)
    },
    renderTime(StatusMinute) {
      var day = parseInt(StatusMinute / 60 / 24)
      var hour = parseInt((StatusMinute / 60) % 24)
      var min = parseInt(StatusMinute % 60)
      StatusMinute = ''
      if (day > 0) {
        StatusMinute = day + '天'
      }
      if (hour > 0) {
        StatusMinute += hour + '小时'
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + '分钟'
      }
      return `（共计${StatusMinute}）`
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  padding: 20px;
  .cell-wrap {
    background: #f7f7fa;
    padding: 5px 15px;
    border-radius: 20px;
    height: 38px;
    border: none;
    width: 100%;
  }
}
.leave-list-wrap {
  .leave-list-title {
    color: #78849e;
    font-size: 0.75rem;
    margin: 1rem;
  }
  .leave-list {
    border-radius: 0.75rem;
    border-radius: 1.0625rem;
    margin: 1rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.1);
    overflow: hidden;
    .leave-list-item {
      display: flex;
      flex-direction: column;
      padding: 0.75rem;

      background: #fff;
      font-size: 0.75rem;
      color: rgba(120, 132, 158, 1);
      border-bottom: 1px solid #f4f4f6;

      .cause {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 0.55rem;
        .status {
          color: #1989fa;
          font-size: 0.85rem;
        }
      }
      .date {
        margin-bottom: 0.55rem;
      }
    }
  }
}
</style>
